import { createSelector } from 'reselect';
import { RootState } from 'src/store';

const getUserSettings = (state: RootState) => state.application.settings;

const getMerchantSettings = createSelector([getUserSettings], (settings) => settings);

export default getMerchantSettings;
